import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DispatchType } from '../../../state/configureStore';
import { Container, Row } from 'reactstrap';
import { Client } from '../../../core/domainModels/clients/Client';
import { searchInObject } from '../../../core/helpers/search';
import { ApplicationState } from '../../../state/ApplicationState';
import { deleteClientThunk, fetchClientsThunk } from '../../../state/clients/reducer';
import { ClipLoader } from '../../components/ClipLoader';
import { TachoConfirmationModal } from '../../components/TachoConfirmationModal';
import { AddClientModal } from '../../modals/clients/AddClientModal';
import { UpdateClientModal } from '../../modals/clients/UpdateClientModal';
import { ClientsTable } from './components/ClientsTable';
import { ClientsToolbar } from './components/ClientsToolbar';

export const ClientsPage = () => {
    const dispatch = useDispatch<DispatchType>();
    const clients = useSelector((state: ApplicationState) => state.clients.clients);
    const fetchUsersPending = useSelector((state: ApplicationState) => state.clients.fetchClientsPending);
    const deleteUsersPending = useSelector((state: ApplicationState) => state.clients.deleteClientPending);
    const deleteUsersError = useSelector((state: ApplicationState) => state.clients.deleteClientError);
    const [isConfirmRemoveModalOpen, setIsConfirmRemoveModalOpen] = useState(false);
    const [isOpenAddClientModal, setIsOpenAddClientModal] = useState(false);
    const [isOpenUpdateClientModal, setIsOpenUpdateClientModal] = useState(false);
    const [selectedClients, setSelectedClients] = useState<Array<Client>>([]);
    const [searchQuery, setSearchQuery] = useState('');
    const clientsToShow = useMemo(() => {
        return searchQuery ? clients.filter((clients: Client) => searchInObject(clients, searchQuery)) : clients;
    }, [clients, searchQuery]);
    return (
        <Container fluid className="flexColumnFullHeightContainer">
            <ClientsToolbar
                selectedClients={selectedClients}
                openAddClientModal={() => setIsOpenAddClientModal(!isOpenAddClientModal)}
                openUpdateClientModal={() => setIsOpenUpdateClientModal(!isOpenUpdateClientModal)}
                openConfirmRemoveModal={() => setIsConfirmRemoveModalOpen(!isConfirmRemoveModalOpen)}
                onRefresh={() => dispatch(fetchClientsThunk())}
                onSearchQueryChanged={setSearchQuery}
            />
            <Row className="ag-theme-balham tabTable flexGrowScrollableChild g-0">
                {fetchUsersPending ? (
                    <ClipLoader />
                ) : (
                    <ClientsTable
                        onClientDoubleClicked={() => setIsOpenUpdateClientModal(!isOpenUpdateClientModal)}
                        onSelectionChanged={setSelectedClients}
                        clients={clientsToShow}
                    />
                )}
            </Row>
            <TachoConfirmationModal
                isOpen={isConfirmRemoveModalOpen}
                onSubmit={() => dispatch(deleteClientThunk(selectedClients[0].id))}
                onToggle={() => setIsConfirmRemoveModalOpen(!isConfirmRemoveModalOpen)}
                message={'clientRemoveConfirmationMessage'}
                pending={deleteUsersPending}
                errorToTranslate={deleteUsersError}
                title={'clientDelete'}
            />
            <AddClientModal isOpen={isOpenAddClientModal} onToggle={() => setIsOpenAddClientModal(!isOpenAddClientModal)} />

            <UpdateClientModal
                client={selectedClients[0]}
                isOpen={isOpenUpdateClientModal}
                onToggle={() => setIsOpenUpdateClientModal(!isOpenUpdateClientModal)}
            />
        </Container>
    );
};
